import script from "./AddCaptureProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCaptureProduct.vue?vue&type=script&setup=true&lang=js"

import "./AddCaptureProduct.vue?vue&type=style&index=0&id=b29915a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b29915a4"]])

export default __exports__